/// <reference types="new-relic-browser" />
import { Button, Logo, WarningIcon } from "@src/components/elements";
import React, { ErrorInfo } from "react";
import { Page } from "@src/shared/pages";
import styled from "styled-components/macro";

type PropsType = { hasError?: boolean; error?: Error; message?: string };

export const StyledRoot = styled.div`
  background: var(--background-gray);
  height: 100vh;
  .warning-container {
    max-width: 40rem;
    margin: 4rem auto;
    padding: 2rem;
    box-shadow: var(--drop-shadow);
    border-radius: var(--rounded-corner);
    background: var(--page-background);

    .warning {
      width: 3rem;
      height: auto;
    }
  }
`;

export class ErrorBoundary extends React.Component<PropsType, PropsType> {
  constructor(props: PropsType) {
    super(props);
    this.state = { ...props } as PropsType;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    try {
      newrelic.noticeError(error);
    } catch {}
    console.error(error, errorInfo);
  }

  render() {
    const message = this.props.message || this.state.error?.message || null;
    if (this.state.hasError) {
      return (
        <StyledRoot className="pad">
          <div className="warning-container">
            <Logo />
            <WarningIcon className="warning margin-top xxl" />

            <h1>Something went wrong.</h1>
            {message && <h2>{message}</h2>}
            <h3>
              Please reach out to{" "}
              <a href="mailto:support@sudozi.com">support@sudozi.com</a> and let
              us know.
            </h3>
            <div>
              <a href={Page.HOME}>
                <Button variant="primary" size="medium">
                  Back to Home
                </Button>
              </a>
            </div>
          </div>
        </StyledRoot>
      );
    }

    return this.props.children;
  }
}
